import { Plus, Shield, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "src/components/ui/button";
import { Input } from "src/components/ui/input";
import Page from "src/layouts/Page";

const Permissions = () => {
	const navigate = useNavigate();

	return (
		<Page>
			<div className="flex flex-col gap-4">
				{/* Actions bar */}
				<div className="flex items-center justify-between gap-4">
					<div className="relative w-full max-w-sm">
						<Search
							className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
							aria-hidden="true"
						/>
						<Input
							aria-label="Search roles"
							placeholder="Search roles..."
							className="pl-9 bg-white"
							disabled
						/>
					</div>
					<Button onClick={() => navigate("/users/permissions/create")}>
						<Plus className="h-4 w-4 mr-1.5" aria-hidden="true" />
						New Role
					</Button>
				</div>

				{/* Empty state */}
				<div className="rounded-xl border border-border bg-subtle shadow-sm p-6">
					<div className="flex flex-col items-center justify-center py-16 text-center">
						<div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-4">
							<Shield className="w-7 h-7 text-primary" aria-hidden="true" />
						</div>
						<p className="text-sm font-medium text-foreground mb-1">
							No roles yet
						</p>
						<p className="text-[13px] text-muted-foreground max-w-md">
							Roles define what users can access and manage. Create your first
							role to start assigning permissions.
						</p>
					</div>
				</div>
			</div>
		</Page>
	);
};

export default Permissions;
